import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useCallback, useRef, useState } from 'react';
import { ownerDocument, useForkRef, useIsFocusVisible } from '@material-ui/core/utils';
import { useId, useControlled } from '@jpmuitk/utils';
import warning from 'warning';
import { getWithDefault } from './internal/getWithDefault'; // eslint-disable-next-line complexity

export function useList() {
  var _keyDownHandlers;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateProps(props);
  var generatedId = useId(props.id);

  var _props$id = props.id,
      id = _props$id === void 0 ? generatedId : _props$id,
      _props$source = props.source,
      source = _props$source === void 0 ? [] : _props$source,
      _props$itemCount = props.itemCount,
      itemCount = _props$itemCount === void 0 ? source.length : _props$itemCount,
      _props$getItemId = props.getItemId,
      getItemId = _props$getItemId === void 0 ? function (index) {
    return "".concat(id, "-item-").concat(index);
  } : _props$getItemId,
      getItemAtIndexProp = props.getItemAtIndex,
      getItemIndexProp = props.getItemIndex,
      _props$displayedItemC = props.displayedItemCount,
      displayedItemCount = _props$displayedItemC === void 0 ? 10 : _props$displayedItemC,
      initialSelectedItem = props.initialSelectedItem,
      selectionVariant = props.selectionVariant,
      disabled = props.disabled,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onSelect = props.onSelect,
      disableMouseDown = props.disableMouseDown,
      restoreLastFocus = props.restoreLastFocus,
      highlightedIndexProp = props.highlightedIndex,
      selectedItemProp = props.selectedItem,
      tabToSelect = props.tabToSelect,
      restProps = _objectWithoutProperties(props, ["id", "source", "itemCount", "getItemId", "getItemAtIndex", "getItemIndex", "displayedItemCount", "initialSelectedItem", "selectionVariant", "disabled", "onBlur", "onChange", "onFocus", "onKeyDown", "onMouseDown", "onMouseLeave", "onSelect", "disableMouseDown", "restoreLastFocus", "highlightedIndex", "selectedItem", "tabToSelect"]);

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _useRef = useRef(selectionVariant === 'deselectable'),
      isDeselectable = _useRef.current;

  var _useRef2 = useRef(selectionVariant === 'multiple' || selectionVariant === 'extended' || Array.isArray(initialSelectedItem) || Array.isArray(selectedItemProp)),
      isMultiSelect = _useRef2.current;

  var _useRef3 = useRef(selectionVariant === 'extended'),
      isExtendedSelect = _useRef3.current;

  var getItemIndex = useCallback(function (item) {
    return source.indexOf(item);
  }, [source]);
  var getItemAtIndex = useCallback(function (index) {
    return source[index];
  }, [source]); // Only use getItemIndex and getItemAtIndex if both are defined; otherwise keep the defaults

  if (typeof getItemIndexProp === 'function' && typeof getItemAtIndexProp === 'function') {
    getItemIndex = getItemIndexProp;
    getItemAtIndex = getItemAtIndexProp;
  }

  var rootRef = useRef();

  var _useState = useState(false),
      focusVisible = _useState[0],
      setFocusVisible = _useState[1];

  var _useControlled = useControlled({
    controlled: selectedItemProp,
    "default": getWithDefault(initialSelectedItem, isMultiSelect ? [] : null),
    name: 'useList',
    state: 'selectedItem'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      selectedItem = _useControlled2[0],
      setSelectedItem = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: highlightedIndexProp,
    name: 'useList',
    state: 'highlightedIndex'
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      highlightedIndex = _useControlled4[0],
      setHighlightedIndex = _useControlled4[1];

  var _useState2 = useState(false),
      quickSelection = _useState2[0],
      setQuickSelection = _useState2[1];

  var handleSingleSelect = useCallback(function (event, index, item) {
    var isSelected = item === selectedItem;
    var nextItem;

    if (isSelected && !isDeselectable) {
      return;
    }

    if (!isSelected) {
      nextItem = item;
      setHighlightedIndex(index);
    } else {
      nextItem = null;
    }

    setSelectedItem(nextItem);

    if (onChange) {
      onChange(event, nextItem);
    }
  }, [isDeselectable, onChange, selectedItem, setHighlightedIndex, setSelectedItem]);
  var handleMultiSelect = useCallback(function (event, index, item) {
    var isSelected = selectedItem.indexOf(item) !== -1;
    var nextItems = selectedItem;

    if (!isSelected) {
      nextItems = nextItems.concat(item);
      setHighlightedIndex(index);
    } else {
      nextItems = nextItems.filter(function (selected) {
        return selected !== item;
      });
    }

    setSelectedItem(nextItems);

    if (onChange) {
      onChange(event, nextItems);
    }
  }, [onChange, selectedItem, setHighlightedIndex, setSelectedItem]);
  var handleRangeSelect = useCallback(function (event, index) {
    var currentSelection = event.ctrlKey ? selectedItem : [];
    var lastSelectedItemIndex = selectedItem.length > 0 ? getItemIndex(selectedItem[selectedItem.length - 1]) : 0;
    var startRegion = Math.min(index, lastSelectedItemIndex);
    var endRegion = Math.max(index, lastSelectedItemIndex);
    var rangeSelection = source.slice(startRegion, endRegion + 1); // concat the current selection with a new selection and remove duplicates for overlaps

    var nextItems = _toConsumableArray(new Set([].concat(_toConsumableArray(currentSelection), _toConsumableArray(rangeSelection)))); // remove text selection caused by shift clicking


    ownerDocument(event.currentTarget).getSelection().removeAllRanges();
    setSelectedItem(nextItems);

    if (onChange) {
      onChange(event, nextItems);
    }
  }, [getItemIndex, onChange, selectedItem, setSelectedItem, source]);
  var handleExtendedSelect = useCallback(function (event, index, item) {
    var nextItems = selectedItem;

    if (event.shiftKey) {
      handleRangeSelect(event, index);
    } else if (selectedItem.length === 0 || event.ctrlKey) {
      handleMultiSelect(event, index, item);
    } else {
      nextItems = [item];
      setSelectedItem(nextItems);

      if (onChange) {
        onChange(event, nextItems);
      }
    }
  }, [handleMultiSelect, handleRangeSelect, onChange, selectedItem, setSelectedItem]);
  var handleSelect = useCallback(function (event, index, item) {
    if (item == null || item.disabled) {
      return;
    }

    if (onSelect) {
      onSelect(event, item);
    }

    if (isExtendedSelect) {
      handleExtendedSelect(event, index, item);
    } else if (isMultiSelect) {
      handleMultiSelect(event, index, item);
    } else {
      handleSingleSelect(event, index, item);
    }
  }, [handleMultiSelect, handleSingleSelect, handleExtendedSelect, isMultiSelect, isExtendedSelect, onSelect]);

  var saveFocusedIndex = function saveFocusedIndex(index) {
    lastHighlightedIndex.current = index;
    return index;
  };

  var lastHighlightedIndex = useRef();

  var getStartingPoint = function getStartingPoint(prevHighlightedIndex) {
    if (prevHighlightedIndex != null && prevHighlightedIndex > -1) {
      return prevHighlightedIndex;
    }

    var lastIndex = lastHighlightedIndex.current; // Clear the lastHighlightedIndex to prevent state leakage.

    lastHighlightedIndex.current = undefined;

    if (restoreLastFocus && lastIndex != null && lastIndex > -1) {
      return lastIndex;
    }

    var selectedItemIndex = getItemIndex(selectedItem);

    if (selectedItemIndex > -1) {
      return selectedItemIndex;
    }

    return quickSelection ? 0 : -1;
  };

  var keyDownHandlers = (_keyDownHandlers = {
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(function (prevHighlightedIndex) {
        var startingPoint = getStartingPoint(prevHighlightedIndex);
        return saveFocusedIndex(Math.max(0, startingPoint - 1));
      });
    },
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(function (prevHighlightedIndex) {
        var startingPoint = getStartingPoint(prevHighlightedIndex);
        return saveFocusedIndex(Math.min(itemCount - 1, startingPoint + 1));
      });
    },
    PageUp: function PageUp(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(function (prevHighlightedIndex) {
        var startingPoint = getStartingPoint(prevHighlightedIndex);
        return saveFocusedIndex(Math.max(0, startingPoint - displayedItemCount));
      });
    },
    PageDown: function PageDown(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(function (prevHighlightedIndex) {
        var startingPoint = getStartingPoint(prevHighlightedIndex);
        return saveFocusedIndex(Math.min(itemCount - 1, startingPoint + displayedItemCount));
      });
    },
    Home: function Home(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(saveFocusedIndex(0));
    },
    End: function End(event) {
      event.preventDefault();
      setQuickSelection(false);
      setHighlightedIndex(saveFocusedIndex(itemCount - 1));
    },
    Enter: function Enter(event) {
      event.preventDefault();
      handleSelect(event, highlightedIndex, getItemAtIndex(highlightedIndex));
    }
  }, _defineProperty(_keyDownHandlers, ' ', function _(event) {
    event.preventDefault();
    handleSelect(event, highlightedIndex, getItemAtIndex(highlightedIndex));
  }), _defineProperty(_keyDownHandlers, "Tab", function Tab(event) {
    if (tabToSelect) {
      handleSelect(event, highlightedIndex, getItemAtIndex(highlightedIndex));
    }
  }), _keyDownHandlers);

  var handleKeyDown = function handleKeyDown(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    var handler = keyDownHandlers[event.key];

    if (handler) {
      handler(event);
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (highlightedIndex === undefined) {
      // Focus on the first, or selected item in the list, if we don't have to restore the last focus
      var indexToFocus = getItemIndex(selectedItem);

      if (restoreLastFocus && lastHighlightedIndex.current != null && lastHighlightedIndex.current > -1) {
        indexToFocus = lastHighlightedIndex.current;
        lastHighlightedIndex.current = null;
      }

      setHighlightedIndex(Math.max(indexToFocus, 0));
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // we have to check if the item receiving focus is inside the list or not,
    // and if it is, we should not reset highlighted index
    if (event.currentTarget && typeof event.currentTarget === 'object') {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setHighlightedIndex(undefined);
        setFocusVisible(false);
        onBlurVisible();
      }
    } else {
      setHighlightedIndex(undefined);
      setFocusVisible(false);
      onBlurVisible();
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (focusVisible) {
      // Get the root node of the component if we have access to it otherwise default to current document
      var rootNode = (rootRef.current || ownerDocument(event.currentTarget)).getRootNode();
      var listNode = rootNode.getElementById(id); // Safety check as `mouseleave` could have been accidentally triggered by an opening tooltip
      // when you use keyboard to navigate, hence the focusVisible check earlier

      if (listNode.contains(event.target)) {
        setHighlightedIndex(function (oldValue) {
          lastHighlightedIndex.current = oldValue;
          return undefined;
        });
      }
    } else {
      setHighlightedIndex(function (oldValue) {
        lastHighlightedIndex.current = oldValue;
        return undefined;
      });
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    if (disableMouseDown) {
      event.preventDefault();
    } else if (onMouseDown) {
      onMouseDown(event);
    }
  };

  var eventHandlers = {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave
  };
  var ariaProps = {
    role: 'listbox',
    'aria-activedescendant': highlightedIndex != null && highlightedIndex > -1 ? getItemId(highlightedIndex) : null
  };

  if (isMultiSelect) {
    ariaProps['aria-multiselectable'] = true;
  }

  return {
    focusableRef: useForkRef(rootRef, focusVisibleRef),
    state: {
      quickSelection: quickSelection,
      id: id,
      focusVisible: focusVisible,
      selectedItem: selectedItem,
      highlightedIndex: highlightedIndex,
      isMultiSelect: isMultiSelect,
      isDisabled: disabled
    },
    helpers: {
      setQuickSelection: setQuickSelection,
      setFocusVisible: setFocusVisible,
      setSelectedItem: setSelectedItem,
      setHighlightedIndex: setHighlightedIndex,
      keyDownHandlers: keyDownHandlers,
      isFocusVisible: isFocusVisible,
      onBlurVisible: onBlurVisible,
      handleSelect: handleSelect
    },
    listProps: _assign({
      id: id,
      source: source,
      itemCount: itemCount,
      disableMouseDown: disableMouseDown,
      displayedItemCount: displayedItemCount,
      getItemAtIndex: getItemAtIndex,
      getItemIndex: getItemIndex,
      getItemId: getItemId,
      disabled: disabled
    }, ariaProps, restProps, disabled ? {} : eventHandlers)
  };
}

var validateProps = function validateProps(props) {
  if (process.env.NODE_ENV !== 'production') {
    var source = props.source,
        itemCount = props.itemCount,
        getItemIndex = props.getItemIndex,
        getItemAtIndex = props.getItemAtIndex,
        checkable = props.checkable,
        selectionVariant = props.selectionVariant,
        initialSelectedItem = props.initialSelectedItem,
        selectedItemProp = props.selectedItemProp;
    var hasIndexer = typeof getItemIndex === 'function' && typeof getItemAtIndex === 'function';
    var hasNoIndexer = getItemIndex === undefined && getItemAtIndex === undefined;
    /* eslint-disable react-hooks/rules-of-hooks */

    useEffect(function () {
      warning(source == null || Array.isArray(source), '`source` for useList must be an array.');
    }, [source]);
    useEffect(function () {
      warning(hasNoIndexer || hasIndexer, 'useList needs to have both `getItemIndex` and `getItemAtIndex`.');
      warning(hasNoIndexer || itemCount !== undefined, 'useList needs to have `itemCount` if an indexer is used.');
    }, [hasIndexer, hasNoIndexer, itemCount]);
    var allowCheckable = selectionVariant === 'multiple' || selectionVariant === 'extended' || Array.isArray(initialSelectedItem) || Array.isArray(selectedItemProp);
    useEffect(function () {
      warning(allowCheckable || !allowCheckable && !checkable, "checkable prop is only available for Multiselect Lists. This list is ".concat(selectionVariant));
    }, [allowCheckable, checkable, selectionVariant]);
    /* eslint-enable react-hooks/rules-of-hooks */
  }
};